import { RootState } from '@reducers';

export const selectFeatureDocument = (state: RootState) => state.featureReducer.documentReducer;
